import type {
  ComponentBlock,
  OrderDetailsV2Normalized,
  OrderDetailV2PageData,
} from "../types";
import type { OrderDetailsV2ApiResponse } from "../types/api";

const asArray = <T>(value: unknown): T[] =>
  Array.isArray(value) ? (value as T[]) : [];

/**
 * Shape we expect at each nesting level after unwrapping the
 * variable-depth backend envelope (`data`, `data.data`, etc.).
 */
interface DataNode {
  components?: unknown;
  pageData?: OrderDetailV2PageData;
  bookingId?: string;
  data?: DataNode;
}

export const normalizeOrderDetailsV2 = (
  raw: OrderDetailsV2ApiResponse
): OrderDetailsV2Normalized => {
  const typedRaw = raw as DataNode;

  const root: DataNode = typedRaw?.data?.components
    ? typedRaw
    : typedRaw?.data?.data?.components
    ? typedRaw.data
    : typedRaw;

  const dataNode: DataNode | undefined = root?.data?.components
    ? root?.data
    : root?.data?.data
    ? root.data.data
    : root?.data;

  const components = asArray<ComponentBlock>(
    dataNode?.components || root?.components
  );
  const pageData: OrderDetailV2PageData =
    dataNode?.pageData || root?.pageData || {};

  const bookingId =
    root?.bookingId ||
    dataNode?.bookingId ||
    pageData?.orderId ||
    pageData?.bookingId ||
    "-";

  const byId: Record<string, unknown> = {};
  for (const block of components) {
    const id = block?.id;
    if (id) byId[id] = block?.data;
  }

  return { bookingId, components, pageData, byId, raw: root };
};
